// store/dataSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchProfile,
} from "./profileThunk";

const initialState = {
  profile: [],
  currentPage: 1,
  totalPages: 1,
  status: "idle",
  error: null,
};

const profileApiSlice = createSlice({
  name: "profileApi",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.status = "success";
        state.profile = action.payload; 
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
  },
});

export default profileApiSlice.reducer;